var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResultsList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F1F8FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.75 12.5H14.25C13.8358 12.5 13.5 12.8358 13.5 13.25V35.75C13.5 36.1642 13.8358 36.5 14.25 36.5H33.75C34.1642 36.5 34.5 36.1642 34.5 35.75V13.25C34.5 12.8358 34.1642 12.5 33.75 12.5ZM14.25 11C13.0074 11 12 12.0074 12 13.25V35.75C12 36.9926 13.0074 38 14.25 38H33.75C34.9926 38 36 36.9926 36 35.75V13.25C36 12.0074 34.9926 11 33.75 11H14.25Z",
    fill: "#022131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 16.25C19.5 15.8358 19.8358 15.5 20.25 15.5L27.75 15.5C28.1642 15.5 28.5 15.8358 28.5 16.25C28.5 16.6642 28.1642 17 27.75 17L20.25 17C19.8358 17 19.5 16.6642 19.5 16.25Z",
    fill: "#022131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 20.75C16.5 20.3358 16.8358 20 17.25 20L18 20C18.4142 20 18.75 20.3358 18.75 20.75C18.75 21.1642 18.4142 21.5 18 21.5L17.25 21.5C16.8358 21.5 16.5 21.1642 16.5 20.75Z",
    fill: "#022131"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 25.25C16.5 24.8358 16.8358 24.5 17.25 24.5L18 24.5C18.4142 24.5 18.75 24.8358 18.75 25.25C18.75 25.6642 18.4142 26 18 26L17.25 26C16.8358 26 16.5 25.6642 16.5 25.25Z",
    fill: "#022131"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 30.5C16.5 30.0858 16.8358 29.75 17.25 29.75L18 29.75C18.4142 29.75 18.75 30.0858 18.75 30.5C18.75 30.9142 18.4142 31.25 18 31.25L17.25 31.25C16.8358 31.25 16.5 30.9142 16.5 30.5Z",
    fill: "#022131"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 23C16.5 22.5858 16.8358 22.25 17.25 22.25L23.25 22.25C23.6642 22.25 24 22.5858 24 23C24 23.4142 23.6642 23.75 23.25 23.75L17.25 23.75C16.8358 23.75 16.5 23.4142 16.5 23Z",
    fill: "#022131"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 27.5C16.5 27.0858 16.8358 26.75 17.25 26.75L30.75 26.75C31.1642 26.75 31.5 27.0858 31.5 27.5C31.5 27.9142 31.1642 28.25 30.75 28.25L17.25 28.25C16.8358 28.25 16.5 27.9142 16.5 27.5Z",
    fill: "#022131"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 32.75C16.5 32.3358 16.8358 32 17.25 32L29.25 32C29.6642 32 30 32.3358 30 32.75C30 33.1642 29.6642 33.5 29.25 33.5L17.25 33.5C16.8358 33.5 16.5 33.1642 16.5 32.75Z",
    fill: "#022131"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsList);
export default __webpack_public_path__ + "static/media/results-list.df38fb8922ce90e41910db7c5edff7b4.svg";
export { ForwardRef as ReactComponent };